/* Hero slideshow — clean rebuild. No dependencies. */
(function () {
  function initHero(root) {
    if (!root || root.dataset.ebHeroInit === '1') return;
    root.dataset.ebHeroInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-eb-hero-slide]'));
    var indicators = Array.prototype.slice.call(root.querySelectorAll('[data-eb-hero-goto]'));
    var prevBtn = root.querySelector('[data-eb-hero-prev]');
    var nextBtn = root.querySelector('[data-eb-hero-next]');
    if (slides.length === 0) return;

    var index = 0;
    var count = slides.length;
    var autoplay = root.dataset.autoplay === 'true' && count > 1;
    var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(next) {
      next = (next + count) % count;
      slides.forEach(function (slide, i) {
        var active = i === next;
        slide.classList.toggle('is-active', active);
        if (active) { slide.removeAttribute('aria-hidden'); }
        else { slide.setAttribute('aria-hidden', 'true'); }
      });
      indicators.forEach(function (ind, i) {
        ind.classList.toggle('is-active', i === next);
        // restart fill animation by forcing reflow
        var fill = ind.querySelector('.eb-hero__indicator-fill');
        if (fill) {
          fill.style.animation = 'none';
          // eslint-disable-next-line no-unused-expressions
          fill.offsetHeight;
          fill.style.animation = '';
        }
      });
      index = next;
    }

    function nextSlide() { show(index + 1); }
    function prevSlide() { show(index - 1); }

    function startAuto() {
      if (!autoplay || reduceMotion) return;
      stopAuto();
      timer = window.setInterval(nextSlide, interval);
    }
    function stopAuto() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }
    function restart() { stopAuto(); startAuto(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { nextSlide(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prevSlide(); restart(); });
    indicators.forEach(function (ind) {
      ind.addEventListener('click', function () {
        show(parseInt(ind.dataset.ebHeroGoto, 10) || 0);
        restart();
      });
    });

    // pause on hover / when tab hidden
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAuto(); else startAuto();
    });

    // basic swipe on touch
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { dx < 0 ? nextSlide() : prevSlide(); restart(); }
      startX = null;
    }, { passive: true });

    show(0);
    startAuto();
  }

  function initAll() {
    document.querySelectorAll('[data-eb-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-eb-hero]');
    if (hero) initHero(hero);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest('[data-eb-hero]');
    if (!hero) return;
    var slide = e.target.closest('[data-eb-hero-slide]');
    if (slide) {
      var idx = parseInt(slide.dataset.index, 10) || 0;
      var indicators = hero.querySelectorAll('[data-eb-hero-goto]');
      if (indicators[idx]) indicators[idx].click();
    }
  });
})();
